import React from 'react';

const elementClassName = 'bata-react-component-state';
const OBJECT_JSON = '{}';

/**
 * Render current state as a component
 */
class AppStateComponent extends React.PureComponent {

    render () {
        const store = this.props.appState;
        const className = elementClassName;
        const json = {__html: store ? JSON.stringify(store.getState()) : '{}'};
        return (
            <script type='application/json' className={className} dangerouslySetInnerHTML={json} suppressHydrationWarning={true}/>
        );
    }
    /**
     * Extract the hydration state form the pre-rendered
     * instance of AppStateComponent, and shallow-merge it with the
     * current initState config (initState takes precidence)
     * @param  {[dom]}  mount     Mount point for the app
     * @param  {Object} initState Current initState from app bootstrap
     * @return {[Object]}         Shallow-merged copy of the adopted (hydrate)
     *                            and current initState
     */
    static hydrateState (mount, initState = {}) {
        if (mount && mount.querySelector) {
            // Grab the pre-rendered string
            const adoptStateString = mount.querySelector('.' + elementClassName);
            if (adoptStateString) {
                // JSON parse the state string into JSON
                const adoptedState = JSON.parse(adoptStateString.innerText || OBJECT_JSON);
                const mergedState = {
                    ...initState,
                    ...adoptedState
                };
                if (adoptedState.config) {
                    mergedState.config = {...adoptedState.config, ...(initState.config || {})};
                }

                const parentNode = adoptStateString.parentNode;
                if (parentNode) {
                    parentNode.removeChild(adoptStateString);
                }
                return mergedState;
            }
        }
        return initState;
    }
}

AppStateComponent.elementClassName = elementClassName;

export default AppStateComponent;
